<template>
  <div class="home">
    <br/>
    <Messages />
    <div>
      <img class="poster-image" :src="`${publicPath}img/Axes2-poster-cropped.png`"/>
      <br/>
      <div v-if="!$auth.isAuthenticated" class="has-text-centered">
        <br/>
        <div class="buttons is-centered">
            <button @click="login" class="button is-primary is-medium home-btn"><strong>Sign In</strong></button>
        </div>
      </div>
    </div>
    <div v-if="$auth.isAuthenticated" class="has-text-centered">
      <div class="buttons is-centered is-flex-direction-column">
          <button @click="startThrowing" class="button is-primary is-large home-btn mb-4">
            <span class="icon"><i class="fas fa-bullseye"></i></span>
            <span>Start Throwing</span>
          </button>
          
          <button @click="$router.push('/uploadsolo')" class="button is-warning is-large home-btn">
            <span class="icon"><i class="fas fa-camera"></i></span>
            <span>Upload Scorecard</span>
          </button>
      </div>
      <br/>
    </div>

    <br/>
    <br/>
    <br/>
    <br/>
    <br/>

  </div>
</template>

<script>
import Messages from '../components/Messages';
import axios from "axios";
import moment from 'moment';

export default {
  name: 'home',
  data () {
    return {
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        playing: false
    }
  },
  methods: {
    isAdmin() {
      return this.$parent.isAdmin();
    },    
    login() {
        this.$auth.loginWithRedirect();
    },
    startThrowing() {
      this.$router.push('throw');
    },
    updateProfile: function(profile) {
      const url = this.$parent.getApiUrl(`profile/auto_update_profile/${profile.email}`);
      const token = this.$parent.getApiToken();
      axios.patch(url, 
        {
          profile: profile
        },
        {
          headers: {
              authorization: token
            }
        }
      );
    },
  },
  components: {
    Messages
  },
  mounted(){
    setTimeout(() => {
      if (this.$auth.isAuthenticated) {

        const d = new Date().UTC;
        var ten_minutes_ago = new moment(d).subtract(1,"minutes");
        
        var updated_date = new  moment.utc(this.$auth.user.updated_at);
        
        if (updated_date > ten_minutes_ago) {
          this.updateProfile(this.$auth.user);
        }
      }
    }, 2000);
  }
}
</script>

<style lang="scss" scoped>
  img {
    max-width: 100%;
    height: auto;
  }

  @media screen and (min-width: 600px) {
    img {
      width: 50%;
    }
  }
  .home {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
      background-color: #181313;
      text-align: center;
      min-height: 90vh;
  }
  .home-btn {
      min-width: 250px;
      font-weight: bold;
      transition: transform 0.1s;
  }
  .home-btn:active {
      transform: scale(0.98);
  }
  .poster-image {
    max-width: 200px;
  }
</style>